export { default } from './Franchise'



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/Franchise/index.js